<template>
    <div
        class="split-row"
        :class="{
            'split-row-maximize': useMaximize,
            'split-row-newline': !oneLine,
            'split-row-reverse': reverse
        }"
    >
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        oneLine: {
            type: Boolean,
            required: false,
            default: false
        },
        maximize: {
            type: Boolean,
            required: false,
            default: false
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        useMaximize() {
            return this.$slots.default.length <= 1 || this.maximize;
        }
    }
};
</script>

<style scoped>
.split-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.split-row.split-row-reverse {
    flex-direction: row-reverse;
}

@media all and (min-width: 820px) {
    .split-row-maximize >>> .field-wrapper-container {
        width: 100%;
    }
}

@media all and (max-width: 819px) {
    .split-row-newline {
        flex-direction: column;
        padding: 5px 0;
    }
    .split-row.split-row-newline.split-row-reverse {
        flex-direction: column-reverse;
    }

    .split-row >>> div {
        /* width: 100%; */
        margin: 5px 0;
    }

    .split-row >>> .field-wrapper > div {
        margin: initial;
    }

    .split-row >>> .dropdown-container {
        /* Fix for a size difference */

        padding: initial;
    }
}
</style>
